import { createStateWithDefaults } from "entities/utils";
import { ChartEntity } from "types";

import { DataEnum, Format } from "models";

export const UNDEFINED_CHART_FEATURES = {
  screenshot: undefined,
  fullScreen: undefined,
  datatable: undefined,
  spaghetti: undefined,
  forecast: undefined,
  source: undefined,
  debug: undefined,
  timeStep: undefined,
  isProducingRateType: undefined,
  cutoff: undefined,
  shutInMonths: undefined,
  movingAverageDays: undefined,
  survivorBias: undefined,
  survivorBiasAsForecast: undefined,
  useWeightedRatioAverage: undefined,
  lockUnits: undefined,
  lasso: undefined,
  typewells: undefined,
  p10: undefined,
  p50: undefined,
  p90: undefined,
  average: undefined,
  normalization: undefined,
  chartFocus: undefined,
  legend: undefined,
  dataTable: undefined,
  pointOpacity: undefined,
  pointSize: undefined,
  lineSize: undefined,
  lineOpacity: undefined,
  highlightedLineSize: undefined,
  highlightedLineOpacity: undefined,
  useSeriesStyleOverride: undefined,
  lassoBrushEnd: undefined,
  lassoBrushPosition: undefined,
  lassoBrushList: undefined,
  annotations: undefined,
  pressureChartSettings: undefined,
  totalFluidChartSettings: undefined,
  histogramToggle: undefined,
  jitterPlotToggle: undefined,
  violinPlotToggle: undefined,
  dataRangeSelect: undefined,
  recoveryPVIRadius: undefined,
  bestFitToggle: undefined,
  calculationMethod: undefined,
  useProbitLineOfBestFitData: undefined,
  useLineOfBestFit: undefined,
  showZeros: undefined,
  hideOthers: undefined,
  logAxis: undefined,
  chartTypeParam: undefined,
  quarterSlope: undefined,
  halfSlope: undefined,
  unitSlope: undefined,
  multiProductFocus: undefined,
  showWellCount: undefined,
  licensedVolumeLine: undefined,
  xAxisFieldSync: undefined,
  boxPlotBins: undefined,
  xAxisSort: undefined,
  workingForecast: undefined,
  multiProduct: undefined,
  splitYear: undefined
};

export const UNDEFINED_CHART_ENTITIES = {
  chartTypeParam: undefined,
  apiResponse: undefined,
  request: undefined,
  options: undefined,
  locks: undefined,
  features: undefined
};

export const UNDEFINED_MPC_LOCKS: import("types/charts/locks").MpcAxisLockMap = {
  x: {},
  y: {}
};

export const UNDEFINED_LOCKS = {
  xMin: {
    value: undefined,
    type: DataEnum.None,
    format: Format.None
  },
  xMax: {
    value: undefined,
    type: DataEnum.None,
    format: Format.None
  },
  yMin: {
    value: undefined,
    type: DataEnum.None,
    format: Format.None
  },
  yMax: {
    value: undefined,
    type: DataEnum.None,
    format: Format.None
  },
  y2Min: {
    value: undefined,
    type: DataEnum.None,
    format: Format.None
  },
  y2Max: {
    value: undefined,
    type: DataEnum.None,
    format: Format.None
  }
};

export const UNDEFINED_CHART_ENTITY: Partial<ChartEntity> = {
  id: "",
  chartType: undefined,
  locks: UNDEFINED_LOCKS,
  mpcLocks: UNDEFINED_MPC_LOCKS,
  screenshot: {
    size: { width: undefined, height: undefined }
  },
  request: undefined,
  response: undefined,
  product: undefined,
  features: UNDEFINED_CHART_FEATURES,
  options: "",
  bounds: undefined,
  overflowIndex: undefined,
  overrideSizeLimit: false,
  highlight: true, // by default, highlight is enabled
  contextMenu: {
    point: null,
    active: false
  }
};

export const generateChartEntity = createStateWithDefaults(UNDEFINED_CHART_ENTITY);
